// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"2467107d","633":"1106a123"}[chunkId] + ".chunk.css";
};